import { render, staticRenderFns } from "./FormStyleV2.vue?vue&type=template&id=219a9ecf"
import script from "./FormStyleV2.vue?vue&type=script&lang=js"
export * from "./FormStyleV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports